export default __webpack_public_path__ + "static/media/fea86b06-bbc8-4e6a-85cc-53ff2cbe1b05.69b1d4ff.woff2";